module.exports = __webpack_public_path__ + "img/TermsofUse_Collapsed_Small_Button.1b2cfb37.svg";